module.exports = __webpack_public_path__ + "/images/cover-celebracion-boda-d.287491f.jpg";